module.exports = __webpack_public_path__ + "img/p6-p1-bg1.7ce4c404.png";